import { FormikProps, getIn } from "formik";

export const isValid = <T>(formik: FormikProps<T>, controlName: string): boolean => {
    return getIn(formik.touched, controlName) && !getIn(formik.errors, controlName);
};

export const isInvalid = <T>(formik: FormikProps<T>, controlName: string): boolean => {
    return getIn(formik.touched, controlName) && !!getIn(formik.errors, controlName);
};